import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminApi, getToken, setToken } from "@/admin/lib";

const AuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(getToken() ? null : false);

  useEffect(() => {
    if (!getToken()) return;
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
  };
  const logout = () => {
    adminApi.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAdminAuth = () => useContext(AuthCtx);

export const Protected = ({ children }) => {
  const { user } = useAdminAuth();
  const loc = useLocation();
  if (user === null)
    return <div className="grid min-h-screen place-items-center bg-page"><div className="h-9 w-9 animate-spin rounded-full border-[3px] border-sky/30 border-t-ocean" /></div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  return children;
};
